import { Component, OnInit, Input } from '@angular/core';
import { Configuration } from '../../../app.constants';
@Component({
  selector: 'app-associate-list-dropdown',
  templateUrl: './associate-list-dropdown.component.html',
  styleUrls: ['./associate-list-dropdown.component.css']
})
export class AssociateListDropdownComponent implements OnInit {

  @Input() associate: any;
  @Input() displayCompany: Boolean = true;
  @Input() isTeam: Boolean = false;

  public serverApiUrl: any;
  constructor( public config:Configuration) { }

  ngOnInit() {
    this.serverApiUrl = this.config.StaticImageUrl;
  }

}
